export const i18nKeysDictionary = {
  REGEX: "alertPasswordFormatError",
  REUSED: "alertPasswordReused",
  CERTAIN_VALUE: "alertPasswordIncludeCertainValue",
};
